const LinkV2Icon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.21894 6.78107C8.17754 5.73966 6.48912 5.73966 5.44772 6.78107L2.78105 9.44774C1.73965 10.4891 1.73965 12.1775 2.78105 13.2189C3.82245 14.2603 5.51089 14.2603 6.55229 13.2189L7.28667 12.4846M6.78107 9.21894C7.82247 10.2603 9.51088 10.2603 10.5523 9.21894L13.2189 6.55229C14.2603 5.51089 14.2603 3.82245 13.2189 2.78105C12.1775 1.73965 10.4891 1.73965 9.44774 2.78105L8.71467 3.51412"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default LinkV2Icon;
